import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { ICON_MAP } from './icon-map';

@Component({
  selector: 'app-icon',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  template: `@if (resolvedIcon) { <lucide-icon [img]="resolvedIcon" [size]="size" [strokeWidth]="strokeWidth"></lucide-icon> }`,
  styles: [`
    :host { display: inline-flex; align-items: center; justify-content: center; line-height: 0; }
    lucide-icon { display: inline-flex; }
  `],
})
export class IconComponent {
  /** Bootstrap Icons class name (without 'bi-' prefix), e.g. 'house-door-fill'.
   *  Also accepts full forms like 'bi-house-door' or 'bi bi-house-door'. */
  @Input() set name(value: string) {
    const cleaned = value
      ?.replace(/^bi\s+bi-/, '')   // strip 'bi bi-' prefix (full class string)
      .replace(/^bi-/, '')          // strip remaining 'bi-' prefix
      .trim();
    this._name = cleaned ?? '';
  }
  get name(): string { return this._name; }

  @Input() size = 20;
  @Input() strokeWidth = 2;

  private _name = '';

  get resolvedIcon(): any {
    return ICON_MAP[this._name] ?? null;
  }
}
